import { render, staticRenderFns } from "./CardCountClassifiedListSMSCampaigns.vue?vue&type=template&id=62a68f72&"
import script from "./CardCountClassifiedListSMSCampaigns.vue?vue&type=script&lang=js&"
export * from "./CardCountClassifiedListSMSCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports